var _defs, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRoad(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_126",
    "data-name": "Group 126",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 697.863,
    height: 33.497,
    viewBox: "0 0 697.863 33.497",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 685.767,
    height: 3.722,
    fill: "none"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2286",
    "data-name": "Path 2286",
    d: "M0,0H697.863V33.5H0Z",
    fill: "rgba(0,0,0,0.81)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Repeat_Grid_1",
    "data-name": "Repeat Grid 1",
    transform: "translate(12.096 14.888)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-187.5 -285)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2287",
    "data-name": "Path 2287",
    d: "M187.5,286h27.194",
    fill: "none",
    stroke: "#d5d2d2",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-117.5 -285)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2287-2",
    "data-name": "Path 2287",
    d: "M187.5,286h27.194",
    fill: "none",
    stroke: "#d5d2d2",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-47.5 -285)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2287-3",
    "data-name": "Path 2287",
    d: "M187.5,286h27.194",
    fill: "none",
    stroke: "#d5d2d2",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.5 -285)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2287-4",
    "data-name": "Path 2287",
    d: "M187.5,286h27.194",
    fill: "none",
    stroke: "#d5d2d2",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(92.5 -285)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2287-5",
    "data-name": "Path 2287",
    d: "M187.5,286h27.194",
    fill: "none",
    stroke: "#d5d2d2",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(162.5 -285)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2287-6",
    "data-name": "Path 2287",
    d: "M187.5,286h27.194",
    fill: "none",
    stroke: "#d5d2d2",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(232.5 -285)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2287-7",
    "data-name": "Path 2287",
    d: "M187.5,286h27.194",
    fill: "none",
    stroke: "#d5d2d2",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(302.5 -285)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2287-8",
    "data-name": "Path 2287",
    d: "M187.5,286h27.194",
    fill: "none",
    stroke: "#d5d2d2",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(372.5 -285)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2287-9",
    "data-name": "Path 2287",
    d: "M187.5,286h27.194",
    fill: "none",
    stroke: "#d5d2d2",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(442.5 -285)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2287-10",
    "data-name": "Path 2287",
    d: "M187.5,286h27.194",
    fill: "none",
    stroke: "#d5d2d2",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoad);
export default __webpack_public_path__ + "static/media/road.5cdc59df.svg";
export { ForwardRef as ReactComponent };